var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _g, _path64, _path65, _path66, _path67, _path68, _path69, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVendorWalkthrough(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 274,
    height: 214,
    viewBox: "0 0 274 214",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_315_1359)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_315_1359)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 11C2 5.47715 6.47715 1 12 1H262C267.523 1 272 5.47715 272 11V211H2V11Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M258.531 -3H16.4687C5.16413 -3 -4 6.99101 -4 19.3155V188.684C-4 201.009 5.16413 211 16.4687 211H258.531C269.836 211 279 201.009 279 188.684V19.3155C279 6.99101 269.836 -3 258.531 -3Z",
    fill: "#1467B0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.05985 211H265.94C278.118 211 288 200.963 288 188.592V179H-17V188.592C-17 200.963 -7.11839 211 5.05985 211Z",
    fill: "#9FC1DF",
    fillOpacity: 0.89
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M200.36 110.537H74.9077V179.001H200.36V110.537Z",
    fill: "#90ADFC"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.32
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M200.36 171.856H74.8188V178.922H200.36V171.856Z",
    fill: "#9FAFFF"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M118.09 69H106.9V93.6782H118.09V69Z",
    fill: "#3E519E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M207.348 110.834H68L75.5026 98.1976H199.855L207.348 110.834Z",
    fill: "#3E519E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M181.668 86.3144H93.6096V179.001H181.668V86.3144Z",
    fill: "#C5CDFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M189.161 98.9409H86.1072L93.6098 86.3144H181.658L189.161 98.9409Z",
    fill: "#5363BC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M119.676 135.443V111.746H106.901V135.443H119.676Z",
    fill: "#9FAFFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M118.09 113.332H108.486V132.261H118.09V113.332Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M119.022 121.211H107.485V122.132H119.022V121.211Z",
    fill: "#9FAFFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M112.034 112.648H111.162V121.934H112.034V112.648Z",
    fill: "#9FAFFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M115.711 112.648H114.839V121.934H115.711V112.648Z",
    fill: "#9FAFFF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M121.152 135.473H105.434V138.347H121.152V135.473Z",
    fill: "#E6EAFF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M121.152 137.138H105.434V138.416H121.152V137.138Z",
    fill: "#9FAFFF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M167.159 135.443V111.746H154.384V135.443H167.159Z",
    fill: "#9FAFFF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M165.573 113.332H155.97V132.261H165.573V113.332Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M166.505 121.211H154.969V122.132H166.505V121.211Z",
    fill: "#9FAFFF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M159.518 112.648H158.646V121.934H159.518V112.648Z",
    fill: "#9FAFFF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M163.195 112.648H162.323V121.934H163.195V112.648Z",
    fill: "#9FAFFF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M168.636 135.473H152.917V138.347H168.636V135.473Z",
    fill: "#E6EAFF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M168.636 137.138H152.917V138.416H168.636V137.138Z",
    fill: "#9FAFFF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M169.26 107.385H104.076V111.736H169.26V107.385Z",
    fill: "#E6EAFF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M130.151 135.552V117.633C130.151 113.787 133.283 110.656 137.129 110.656C140.974 110.656 144.106 113.787 144.106 117.633V135.552H130.161H130.151Z",
    fill: "#9FAFFF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M142.639 134.095H131.598V117.633C131.598 114.58 134.066 112.113 137.119 112.113C140.171 112.113 142.639 114.58 142.639 117.633V134.095Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M143.591 120.081V118.981H130.657V120.081H143.591Z",
    fill: "#9FAFFF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M137.783 111.339H136.712V119.625H137.783V111.339Z",
    fill: "#9FAFFF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M144.889 135.473H129.17V138.347H144.889V135.473Z",
    fill: "#E6EAFF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M144.889 137.138H129.17V138.416H144.889V137.138Z",
    fill: "#9FAFFF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M131.281 115.492H142.649C142.649 115.492 141.945 111.528 137.783 111.349C133.62 111.171 131.281 115.492 131.281 115.492Z",
    fill: "#9FAFFF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M181.668 171.935H93.6096V179.001H181.668V171.935Z",
    fill: "#9FAFFF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M146.951 147.029H126.921V179.001H146.951V147.029Z",
    fill: "#5363BC"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M144.889 149.259H129.17V179.001H144.889V149.259Z",
    fill: "#3E51A3"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M149.23 175.473H124.829V179.001H149.23V175.473Z",
    fill: "#E6EAFF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M144.84 171.935H129.18V175.463H144.84V171.935Z",
    fill: "#AEBEFF"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M143.591 151.171H130.657V155.493H143.591V151.171Z",
    fill: "#5363BC"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M143.591 156.731H130.657V170.607H143.591V156.731Z",
    fill: "#5363BC"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M141.351 161.905C142.068 161.905 142.649 161.324 142.649 160.607C142.649 159.89 142.068 159.308 141.351 159.308C140.634 159.308 140.052 159.89 140.052 160.607C140.052 161.324 140.634 161.905 141.351 161.905Z",
    fill: "#E6EAFF"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9814 149.15V133.104H80.3292V149.15H88.9814Z",
    fill: "#5571D8"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M87.911 134.174H81.4094V146.989H87.911V134.174Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5354 139.516H80.7256V140.141H88.5354V139.516Z",
    fill: "#5571D8"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M83.808 133.718H83.2134V140.002H83.808V133.718Z",
    fill: "#5571D8"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2956 133.718H85.7009V140.002H86.2956V133.718Z",
    fill: "#5571D8"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9724 149.179H79.3281V151.132H89.9724V149.179Z",
    fill: "#E6EAFF"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M89.9724 150.299H79.3281V151.162H89.9724V150.299Z",
    fill: "#9FAFFF"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M195.464 149.15V133.104H186.812V149.15H195.464Z",
    fill: "#5571D8"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M194.384 134.174H187.882V146.989H194.384V134.174Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M195.009 139.516H187.199V140.141H195.009V139.516Z",
    fill: "#5571D8"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M190.281 133.718H189.687V140.002H190.281V133.718Z",
    fill: "#5571D8"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M192.778 133.718H192.184V140.002H192.778V133.718Z",
    fill: "#5571D8"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M196.455 149.179H185.811V151.132H196.455V149.179Z",
    fill: "#E6EAFF"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M196.455 150.299H185.811V151.162H196.455V150.299Z",
    fill: "#9FAFFF"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M197.889 131.038C197.889 131.038 196.607 130.373 196.461 129.515C196.314 128.656 205.542 121.808 206.984 121.614C208.425 121.42 214.453 121.581 215.669 122.66C216.885 123.739 226.736 134.368 227.911 136.892C229.085 139.414 227.889 170.932 227.889 170.932L231.214 241H198.878L208.797 171.943C201.73 163.401 204.645 156.205 204.645 156.205C204.645 156.205 199.735 154.359 199.002 150.932C198.6 149.049 203.254 144.185 203.956 144.045C204.661 143.906 205.194 143.947 205.194 143.947L205.26 139.865L202.869 140.177C201.977 143.638 198.283 145.66 196.859 144.255C195.435 142.849 198.88 137.932 198.88 137.932C194.617 141.286 191.144 139.181 191.238 137.823C191.332 136.467 197.889 131.038 197.889 131.038Z",
    fill: "#D88C79"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M197.545 137.038C200.902 138.76 205.062 135.948 205.062 135.948",
    stroke: "#251B37",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M198.533 143.932C199.391 143.223 200.668 142.079 200.668 142.079C203.247 142.38 205.04 141.659 205.04 141.659",
    stroke: "#251B37",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M202.396 145.553C202.416 144.904 202.282 144.248 202.011 143.657",
    stroke: "#251B37",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M200.742 141.284C200.919 140.351 200.876 139.375 200.611 138.461",
    stroke: "#251B37",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M219.308 140.968C217.424 141.173 215.493 140.915 213.73 140.227",
    stroke: "#251B37",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M204.791 124.134L206.867 123.767L204.717 111.681L202.641 112.048L204.791 124.134Z",
    fill: "#675387"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M209.757 107.13C221.804 102.039 227.429 88.1806 222.32 76.176C217.211 64.1714 203.304 58.5666 191.256 63.6573C179.209 68.748 173.585 82.6065 178.693 94.6111C183.802 106.616 197.71 112.22 209.757 107.13Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M174.008 90.0699C176.603 104.654 190.568 114.38 205.204 111.794C219.839 109.208 229.6 95.292 227.005 80.7084C224.41 66.1276 210.445 56.3983 195.809 58.9844C181.174 61.5704 171.413 75.4862 174.008 90.0699ZM177.176 89.5109C174.891 76.6719 183.485 64.4183 196.373 62.1412C209.258 59.864 221.555 68.4283 223.84 81.2703C226.125 94.1093 217.53 106.363 204.643 108.64C191.758 110.917 179.461 102.353 177.176 89.5109Z",
    fill: "#90ADFC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_315_1359",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 176,
    y: 61,
    width: 49,
    height: 48
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M217.262 102.084C226.514 92.8638 226.514 77.9149 217.262 68.6947C208.009 59.4745 193.007 59.4745 183.754 68.6947C174.501 77.9149 174.501 92.8638 183.754 102.084C193.007 111.304 208.009 111.304 217.262 102.084Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_315_1359)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.171 118.434L225.142 110.492L222.541 95.8668L177.57 103.809L180.171 118.434Z",
    fill: "white"
  }))), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M210.109 148.025C211.673 147.748 212.716 146.262 212.439 144.703L208.381 121.897C208.219 120.988 207.349 120.383 206.437 120.544L204.077 120.96C203.165 121.121 202.557 121.989 202.718 122.898L206.776 145.704C207.054 147.262 208.545 148.302 210.109 148.025Z",
    fill: "#C64B4B"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M219.732 154.158C219.732 154.158 215.972 151.1 215.307 150.024C214.642 148.947 212.641 133.836 212.317 131.796C211.701 127.913 205.863 126.374 205.073 132.847L204.852 159.099L219.734 154.158H219.732Z",
    fill: "#D88C79"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M208.697 129.443C209.583 129.408 210.329 129.916 210.758 130.408C210.955 130.635 211.071 130.92 211.099 131.221L211.3 133.396C211.333 133.756 211.127 134.1 210.788 134.229C209.161 134.848 207.348 134.261 207.348 134.261",
    stroke: "#251B37",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M211.184 139.074C210.342 139.479 209.34 139.54 208.455 139.239",
    stroke: "#251B37",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M215.307 150.023C214.642 148.947 212.641 133.836 212.317 131.796C211.701 127.913 205.863 126.374 205.073 132.847L205.027 145.763",
    stroke: "#251B37",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M204.85 149.947L204.312 160.694",
    stroke: "#251B37",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_315_1359)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.372 99.3833L191.588 101.41C191.065 101.499 190.566 101.147 190.476 100.624L189.697 96.0941C189.315 93.876 190.471 91.6566 192.507 90.6967L198.047 88.0837L197.801 86.6523C197.77 86.4693 197.893 86.2953 198.076 86.2638C198.259 86.2323 198.433 86.3553 198.464 86.5383L198.754 88.2218C198.779 88.3703 198.702 88.5186 198.566 88.583L192.794 91.3052C191.03 92.1364 190.029 94.0589 190.36 95.9801L191.139 100.51C191.166 100.667 191.316 100.774 191.474 100.747L215.083 96.6869C215.24 96.6599 215.346 96.5095 215.319 96.3518L214.54 91.8222C214.21 89.901 212.624 88.4239 210.685 88.2289L204.335 87.5909C204.185 87.5759 204.062 87.4619 204.037 87.3134L203.743 85.6063C203.712 85.4232 203.835 85.2493 204.018 85.2178C204.201 85.1862 204.375 85.3093 204.406 85.4923L204.657 86.9472L210.752 87.5595C212.991 87.7842 214.822 89.4901 215.203 91.7082L215.982 96.2378C216.072 96.7609 215.72 97.26 215.197 97.3499L203.372 99.3833Z",
    fill: "#5363BC",
    stroke: "#5363BC",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.758 90.0031C200.04 90.2986 198.291 89.5037 198.09 88.3347C198.059 88.1517 198.181 87.9777 198.364 87.9462C198.548 87.9147 198.722 88.0377 198.753 88.2207C198.875 88.9321 200.192 89.5898 201.644 89.3401C203.189 89.0744 204.145 87.9447 204.037 87.3122C204.005 87.1291 204.128 86.9551 204.311 86.9237C204.495 86.8921 204.668 87.0152 204.7 87.1982C204.901 88.3671 203.498 89.7039 201.758 90.0031Z",
    fill: "#5363BC",
    stroke: "#5363BC",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.477 80.1522C205.402 80.1651 205.321 80.1523 205.25 80.1112C205.09 80.0173 205.036 79.8115 205.13 79.6508C205.868 78.3855 206.136 77.1324 205.927 75.9252C205.753 74.9246 205.326 74.3836 205.301 74.3529C205.253 74.3078 205.217 74.2465 205.201 74.1821C204.57 71.4494 201.962 70.9206 199.886 70.9577C198.231 70.9875 196.638 71.4817 195.282 72.3869C192.361 74.3332 192.624 76.9908 193.04 78.4024C193.571 80.2025 194.631 81.2019 194.886 81.2055C195.071 81.1979 195.227 81.3423 195.235 81.5277C195.243 81.7136 195.097 81.8707 194.912 81.8776C194.148 81.9088 193 80.4637 192.454 78.7846C192.061 77.5752 192.006 76.358 192.296 75.2647C192.658 73.8976 193.537 72.7409 194.909 71.8271C196.372 70.8502 198.089 70.3173 199.874 70.2848C201.252 70.2606 202.433 70.4759 203.382 70.9253C204.667 71.5329 205.492 72.55 205.837 73.9489C206.036 74.1993 206.407 74.8382 206.577 75.7388C206.756 76.6933 206.751 78.2058 205.711 79.99C205.659 80.0795 205.572 80.136 205.477 80.1522Z",
    fill: "#5363BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.301 74.3529C205.303 74.3549 205.304 74.3564 205.306 74.3574M205.301 74.3529C205.326 74.3836 205.753 74.9246 205.927 75.9252C206.136 77.1324 205.868 78.3855 205.13 79.6508C205.036 79.8115 205.09 80.0173 205.25 80.1112C205.321 80.1523 205.402 80.1651 205.477 80.1522C205.572 80.136 205.659 80.0795 205.711 79.99C206.751 78.2058 206.756 76.6933 206.577 75.7388C206.407 74.8382 206.036 74.1993 205.837 73.9489C205.492 72.55 204.667 71.5329 203.382 70.9253C202.433 70.4759 201.252 70.2606 199.874 70.2848C198.089 70.3173 196.372 70.8502 194.909 71.8271C193.537 72.7409 192.658 73.8976 192.296 75.2647C192.006 76.358 192.061 77.5752 192.454 78.7846C193 80.4637 194.148 81.9088 194.912 81.8776C195.097 81.8707 195.243 81.7136 195.235 81.5277C195.227 81.3423 195.071 81.1979 194.886 81.2055C194.631 81.2019 193.571 80.2025 193.04 78.4024C192.624 76.9908 192.361 74.3332 195.282 72.3869C196.638 71.4817 198.231 70.9875 199.886 70.9577C201.962 70.9206 204.57 71.4494 205.201 74.1821C205.217 74.2465 205.253 74.3078 205.301 74.3529Z",
    stroke: "#5363BC",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.806 77.9974C194.76 78.0053 194.728 78.0309 194.712 78.048C194.689 78.0721 194.652 78.1234 194.665 78.1994L195.42 82.5897C195.887 85.3039 198.474 87.1321 201.188 86.6654C203.902 86.1987 205.731 83.6112 205.264 80.8969L204.509 76.5066C204.496 76.4307 204.444 76.394 204.414 76.3796C204.385 76.365 204.326 76.3457 204.258 76.381C203.026 77.0189 201.353 77.5507 199.67 77.8401C197.987 78.1295 196.234 78.1868 194.86 77.997C194.84 77.9939 194.822 77.9947 194.806 77.9974ZM201.302 87.3284C198.223 87.858 195.286 85.7834 194.757 82.7037L194.002 78.3134C193.956 78.044 194.038 77.7768 194.228 77.58C194.418 77.3838 194.682 77.2928 194.952 77.3305C196.26 77.5115 197.938 77.4553 199.556 77.1771C201.174 76.8988 202.775 76.3913 203.948 75.7836C204.191 75.6583 204.469 75.6555 204.714 75.777C204.959 75.899 205.126 76.1233 205.172 76.3927L205.927 80.7829C206.457 83.8627 204.382 86.7988 201.302 87.3284Z",
    fill: "#5363BC",
    stroke: "#5363BC",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.139 92.8899C206.956 92.9213 206.782 92.7989 206.75 92.6159L205.87 87.497C205.839 87.3139 205.962 87.14 206.145 87.1085C206.328 87.077 206.502 87.2 206.533 87.383L207.413 92.5019C207.445 92.6849 207.322 92.8584 207.139 92.8899Z",
    fill: "#5363BC",
    stroke: "#5363BC",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.094 98.3981C208.911 98.4296 208.737 98.3072 208.706 98.1242L207.831 93.0398C207.807 92.8959 207.669 92.7987 207.525 92.8234L197.306 94.5806C197.162 94.6053 197.065 94.7429 197.09 94.8868L197.964 99.9711C197.996 100.154 197.873 100.328 197.69 100.359C197.507 100.391 197.333 100.268 197.301 100.085L196.427 95.0008C196.339 94.4914 196.683 94.0057 197.192 93.9181L207.411 92.1609C207.921 92.0732 208.407 92.4164 208.494 92.9258L209.369 98.0101C209.4 98.1932 209.277 98.3666 209.094 98.3981Z",
    fill: "#5363BC",
    stroke: "#5363BC",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.827 98.7879C206.644 98.8194 206.47 98.697 206.438 98.514L205.911 95.4474C205.91 95.4411 205.903 95.437 205.897 95.4381L199.714 96.5012C199.708 96.5023 199.703 96.5085 199.704 96.5148L200.231 99.5813C200.263 99.7644 200.14 99.9377 199.957 99.9693C199.774 100.001 199.6 99.8784 199.568 99.6954L199.041 96.6288C198.977 96.257 199.228 95.9022 199.6 95.8382L205.783 94.775C206.155 94.711 206.51 94.9617 206.574 95.3335L207.102 98.3999C207.133 98.583 207.01 98.7564 206.827 98.7879Z",
    fill: "#5363BC",
    stroke: "#5363BC",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.693 94.5142C197.51 94.5457 197.336 94.4233 197.304 94.2403L196.424 89.1213C196.393 88.9383 196.515 88.7643 196.698 88.7328C196.882 88.7013 197.056 88.8243 197.087 89.0073L197.967 94.1262C197.999 94.3092 197.876 94.4827 197.693 94.5142Z",
    fill: "#5363BC",
    stroke: "#5363BC",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.554 97.1994L199.684 98.3808C199.501 98.4123 199.327 98.2894 199.295 98.1063C199.264 97.9233 199.387 97.7493 199.57 97.7178L206.44 96.5364C206.623 96.5049 206.797 96.6279 206.828 96.811C206.86 96.9939 206.737 97.168 206.554 97.1994Z",
    fill: "#5363BC",
    stroke: "#5363BC",
    strokeWidth: 0.3
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_315_1359",
    x: 0,
    y: 0,
    width: 274,
    height: 214,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_315_1359"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_315_1359",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_315_1359"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 11C2 5.47715 6.47715 1 12 1H262C267.523 1 272 5.47715 272 11V211H2V11Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_315_1359"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.7316,
    height: 32.7316,
    fill: "white",
    transform: "translate(182 71.5469) rotate(-9.75674)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendorWalkthrough);
export default __webpack_public_path__ + "static/media/VendorWalkthrough.5dbae1f74a8a097d9b5d2653486f85b3.svg";
export { ForwardRef as ReactComponent };